import { useEffect, useState } from "react";

export interface SpinnerProps {
  className?: string;
}

const FRAMES = ["⠋", "⠙", "⠹", "⠸", "⠼", "⠴", "⠦", "⠧"];

export function Spinner({ className = "" }: SpinnerProps) {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % FRAMES.length), 110);
    return () => clearInterval(t);
  }, []);
  return (
    <span className={`mono inline-block ${className}`} style={{ width: "1ch" }}>
      {FRAMES[i]}
    </span>
  );
}
